import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import NotificationBuilder from '../../utils/NotificationBuilder';
import { useTranslation } from 'react-i18next';
import { mapSocketFactory } from '../../../../utils/socketFactory';
import { addNotification } from '../../store/notificationsSlice';
import { joinRoomSocket, leaveRoomSocket } from '../../../Map/store/MapDisplaySlice';


export default function useNotificationTriggers() {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { currentRoom } = useSelector((state) => state.MapDisplay);

    const { selectedSpeaker } = useSelector((state) => state.mediaControls);
    const selectedSpeakerRef = useRef(selectedSpeaker);

    // Keep selectedSpeakerRef in sync
    useEffect(() => {
        selectedSpeakerRef.current = selectedSpeaker;
    }, [selectedSpeaker]);


    useEffect(() => {
        if (!currentRoom?.room_id) return;

        const onJoinRoom = async (payload) => {
            try {
                const notification = NotificationBuilder.info()
                    .withHeader('user_joined_room', true)
                    .withMessage('user_joined_room_msg', true, { name: payload.data })
                    .withLucideIcon('log-in')
                    .withSound('room_enter.wav')
                    .build();
                dispatch(addNotification(notification));


                if (document.hidden) {
                    if (Notification?.permission === "granted") {
                        new Notification(t('user_joined_room'), {
                            body: t('user_joined_room_msg', { name: payload.data }),
                            // icon: "/favicon.ico", // optionnel
                        });
                    } else {
                        // optionnel: demander une seule fois au moment opportun dans l’app (settings)
                        await Notification.requestPermission();
                    }
                }


            } catch (error) {
                console.error("Erreur de lecture audio:", error);
            }
        };

        const onLeaveRoom = async (payload) => {
            try {

                const audio = new Audio('room_leaving.wav');
                if (selectedSpeakerRef.current?.deviceId && audio.setSinkId) {
                    await audio.setSinkId(selectedSpeakerRef.current.deviceId);
                }
                await audio.play();
            } catch (error) {
                console.error("Erreur de lecture audio:", error);
            }
        };

        // Store the listener objects returned by the `on` method
        let joinRoomListener;
        let leaveRoomListener;

        // Dispatch pour rejoindre la salle
        dispatch(joinRoomSocket({ roomId: currentRoom.room_id }));

        // Ecouter les événements and store the returned listener objects
        mapSocketFactory.on(`onjoinRoom-${currentRoom.room_id}`, onJoinRoom).then(listener => {
            joinRoomListener = listener;
        });
        mapSocketFactory.on(`onLeaveRoom-${currentRoom.room_id}`, onLeaveRoom).then(listener => {
            leaveRoomListener = listener;
        });

        // Cleanup des listeners
        return () => {
            dispatch(leaveRoomSocket({ roomId: currentRoom.room_id }));

            // Use the stored listener objects
            if (joinRoomListener) {
                mapSocketFactory.off(joinRoomListener);
            }
            if (leaveRoomListener) {
                mapSocketFactory.off(leaveRoomListener);
            }
        };
    }, [currentRoom]);

}
